export default __webpack_public_path__ + "static/media/Natural Cosas Lindas.46b56085.jpg";